import dayjs from 'dayjs';
import { floorOver2DecimalPoint, floorOverDigits, replaceHalfWidthNumber } from '../util';
export const MAX_WEIGHT_DIGITS = 3;
export class UserWeight {
    constructor(v) {
        Object.defineProperty(this, "weight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "targetDateAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.weight = v.weight;
        this.targetDateAt = dayjs.unix(v.targetDateAt);
    }
    static formatWeight(weight) {
        let value = replaceHalfWidthNumber(weight);
        value = floorOver2DecimalPoint(value);
        return floorOverDigits(value, MAX_WEIGHT_DIGITS);
    }
}
export class WeightAndBodyFatActivities {
    constructor(v) {
        Object.defineProperty(this, "weightAndBodyFatActivityList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weightGraphScales", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bodyFatGraphScales", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.weightAndBodyFatActivityList = v.weightAndBodyFatActivityList.map((v) => new WeightAndBodyFatActivity(v));
        this.weightGraphScales = v.weightGraphScales;
        this.bodyFatGraphScales = v.bodyFatGraphScales;
    }
}
export class WeightAndBodyFatActivity {
    constructor(v) {
        Object.defineProperty(this, "weight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bodyFat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dateAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.weight = v.weight;
        this.bodyFat = v.bodyFat;
        this.dateAt = dayjs.unix(v.dateAt);
    }
}
export class TargetWeightAndBodyFat {
    constructor(v) {
        Object.defineProperty(this, "weight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weightDateAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bodyFat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bodyFatDateAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.weight = v.weight;
        this.weightDateAt = dayjs.unix(v.weightDateAt);
        this.bodyFat = v.bodyFat;
        this.bodyFatDateAt = dayjs.unix(v.bodyFatDateAt);
    }
    static formatWeight(weight) {
        let value = replaceHalfWidthNumber(weight);
        value = floorOver2DecimalPoint(value);
        return floorOverDigits(value, MAX_WEIGHT_DIGITS);
    }
}
